class IndustryFaqAccordion extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.iq-faq-item'));
    this.items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (item.open) {
          this.items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        }
      });
    });
  }
}

customElements.define('industry-faq-accordion', IndustryFaqAccordion);